export enum Integrations {
  ConnectWise = 'ConnectWise',
  Autotask = 'Autotask',
  Halo = 'Halo',
  Kaseya = 'Kaseya',
  Syncro = 'SyncroMSP',
  ServiceNow = 'ServiceNow',
  SuperOps = 'SuperOps',
  Zendesk = 'Zendesk',
  Microsoft = 'Microsoft',
  ImportIntegration = 'ImportIntegration',
  FreshService = 'FreshService',
}

export enum IntegrationsByIndex {
  'ConnectWise',
  'Autotask',
  'Kaseya',
  'ServiceNow',
  'SyncroMSP',
  'Halo',
  'Zendesk',
  SuperOps,
  Microsoft,
  ImportIntegration,
  FreshService,
}

export enum IntegrationsLabels {
  ConnectWise = 'ConnectWiseRestApi',
  Autotask = 'Autotask',
  Halo = 'Halo',
}
